import React from 'react';
import Layout from '../../components/Layout';
import { BarChart3Icon } from 'lucide-react';
const Reports: React.FC = () => {
  return <Layout title="Reports & Insights" persona="University Coordinator" universityName="UAE Business School" data-id="element-6462">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-6463">
        <div className="text-center py-16" data-id="element-6464">
          <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-6465">
            <BarChart3Icon className="w-8 h-8 text-gray-400" data-id="element-6466" />
          </div>
          <h3 className="text-gray-500 font-medium mb-2" data-id="element-6467">
            Reports content coming soon
          </h3>
          <p className="text-gray-400 text-sm max-w-md mx-auto" data-id="element-6468">
            This page will provide analytics, insights, and reports about
            programs and applications.
          </p>
        </div>
      </div>
    </Layout>;
};
export default Reports;